<template>
  <div>
    <b-overlay :show="busy" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.saving") }}...
          </strong>
        </div>
        <div v-else-if="isLoading" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.loading") }}...
          </strong>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        ></div>
      </template>
    </b-overlay>

    <b-card>
      <b-tabs pills align="center">
        <validation-observer ref="headerForm">
          <b-card-text class="card-title"
            >เปลี่ยนรหัสผ่าน (Change Password)</b-card-text
          >
          <hr />
          <b-card>
            <div class="card container col-lg-6 col-md-6 ml-auto mr-auto">
              <b-row class="pt-2">
                <b-col md="12">
                  <b-form-group
                    label-for="i-old-password"
                    :label="locals('select.old_pass')"
                    class="title-freight-require"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Old Password"
                    >
                      <b-form-input
                        id="i-old-password"
                        type="password"
                        autocomplete="off"
                        v-model="listData.strOldPassword"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label-for="i-input-password"
                    :label="locals('select.new_pass')"
                    class="title-freight-require"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Input Password"
                    >
                      <b-form-input
                        id="i-input-password"
                        type="password"
                        autocomplete="off"
                        v-model="listData.strInputPassword"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small class="text-danger">{{ listData.errors1 }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label-for="i-confirm-password"
                    :label="locals('select.comfirm_pass')"
                    class="title-freight-require"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Confirm Password"
                    >
                      <b-form-input
                        id="i-confirm-password"
                        type="password"
                        autocomplete="off"
                        v-model="listData.strConfirmPassword"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small class="text-danger">{{ listData.errors2 }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </validation-observer>
      </b-tabs>
      <b-row>
        <b-col class="d-flex justify-content-center demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1 btn-fixed-width"
            pill
            @click="onSubmit('Submit')"
          >
            <font-awesome-icon icon="fa-solid fa-check" />
            {{ $t("button.submit") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="submit"
            class="mr-1 btn-fixed-width"
            variant="outline-warning"
            pill
            @click="onBack"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseCheck from "@core/components/app-collapse/AppCollapseCheck.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import flatPickr from "vue-flatpickr-component";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import Cleave from "vue-cleave-component";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import base64toblob from "base64toblob";

import {
  BTable,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BInputGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BFormCheckbox,
  BFormTextarea,
  BFormSelect,
  BPagination,
  BInputGroupPrepend,
  BFormFile,
  BTabs,
  BTab,
  BCardText,
  BModal,
  VBModal,
  BSpinner,
  BOverlay,
  VBTooltip,
} from "bootstrap-vue";

import Service from "@/@API/cDropdown";
import UserService from "@/@API/cUser";

export default {
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BTable,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    AppCollapse,
    AppCollapseItem,
    AppCollapseCheck,
    BFormRadio,
    BInputGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BFormCheckbox,
    BFormSelect,
    vSelect,
    flatPickr,
    BFormTextarea,
    VueGoodTable,
    BPagination,
    BInputGroupPrepend,
    BButton,
    BFormFile,
    Cleave,
    BTabs,
    BTab,
    BCardText,
    BModal,
    VBModal,
    BSpinner,
    BOverlay,
    VBTooltip,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      strInputStatus: "",
      strStatusShow: "",
      showCustomerName: "",
      showStatus: "",
      showBy: "",
      busy: true,
      processing: false,
      isLoading: true,
      isSaving: false,
      listData: {
        intUserId: -1,
        strOldPassword: "",
        strInputPassword: "",
        strConfirmPassword: "",
      },
    };
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  mounted() {
    this.busy = false;
    this.processing = false;

    let Id = localStorage.getItem("uid");
    this.listData.intUserId = Id;
  },
  methods: {
    validatePassword(value) {
      // Check if the password is at least 8 characters, contains at least one letter and one number
      const passwordRegex =
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()-_=+{}[\];:'",.<>?/~`]{8,}$/;

      var isValid = passwordRegex.test(value);

      if (value == "" || !isValid) {
        return "Passwords must be a minimum of 8 characters in length , include at least one letter , one numeral.";
      }
      return "";
    },
    onSubmit(inputstatus) {
      let lang = localStorage.getItem("language");

      let ifcomp = true;
      let errorsmsg = "";

      this.listData.errors1 = "";
      this.listData.errors2 = "";

      this.listData.errors1 = this.validatePassword(
        this.listData.strInputPassword
      );
      this.listData.errors2 = this.validatePassword(
        this.listData.strConfirmPassword
      );

      if (this.listData.errors1 != "" && this.listData.errors2 != "") {
        ifcomp = false;
      }
      if (this.listData.strOldPassword == "") {
        ifcomp = false;
        if (lang == "th_TH") {
          errorsmsg = errorsmsg + "ใส่รหัสผ่านเดิม , ";
        } else {
          errorsmsg = errorsmsg + "Old Password , ";
        }
      }
      if (
        this.listData.strInputPassword == "" ||
        this.listData.strConfirmPassword == ""
      ) {
        ifcomp = false;
        if (lang == "th_TH") {
          errorsmsg = errorsmsg + "ใส่รหัสผ่านใหม่ให้ครบถ้วน , ";
        } else {
          errorsmsg = errorsmsg + "New Password is require. , ";
        }
      }

      this.$refs.headerForm.validate().then((success) => {
        if (success) {
          if (
            this.listData.strOldPassword != "" &&
            this.listData.strInputPassword != "" &&
            this.listData.strConfirmPassword != "" &&
            this.listData.strOldPassword == this.listData.strInputPassword &&
            this.listData.strInputPassword == this.listData.strConfirmPassword
          ) {
            ifcomp = false;
            if (lang == "th_TH") {
              this.listData.error2 = "รหัสผ่านซ้ำ!";
              errorsmsg = errorsmsg + "รหัสผ่านซ้ำ";
            } else {
              this.listData.error2 = "Same Password !";
              errorsmsg = errorsmsg + "Same Password ";
            }
          }
          if (
            this.listData.strInputPassword != "" &&
            this.listData.strConfirmPassword != "" &&
            this.listData.strInputPassword != this.listData.strConfirmPassword
          ) {
            ifcomp = false;
            if (lang == "th_TH") {
              this.listData.error2 = "รหัสผ่านไม่ตรงกัน!";
              errorsmsg = errorsmsg + "รหัสผ่านไม่ตรงกัน";
            } else {
              this.listData.error2 = "Password confirmation does not match.!";
              errorsmsg = errorsmsg + " Password confirmation does not match.";
            }
          }

          if (!ifcomp) {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "WARNING!!",
                  icon: "AlertCircleIcon",
                  variant: "danger",
                  text: "" + errorsmsg,
                },
              },
              {
                position: "top-center",
                timeout: 10000,
              }
            );
            return;
          }
          //ifcomp
          if (ifcomp) {
            this.busy = false;
            this.processing = false;
            //this.busy = true;
            this.strInputStatus = inputstatus;
            this.strStatusShow = "Confirm " + inputstatus;
            let b1 = inputstatus;
            let b2 = "Cancel";

            if (lang == "th_TH") {
              b1 = "ยืนยัน";
              b2 = "ยกเลิก";
              this.strStatusShow = "ยืนยันการเปลี่ยนรหัสผ่าน";
            }

            this.$bvModal
              .msgBoxConfirm(this.strStatusShow, {
                title: this.strStatusShow,
                size: "sm",
                modalClass: "modal-success",
                okVariant: "success",
                okTitle: b1,
                cancelTitle: b2,
                cancelVariant: "outline-warning",
                hideHeaderClose: false,
                //centered: true,
              })
              .then((value) => {
                if (value) {
                  this.onSave();
                }
              });
          }
        } else {
          let message = "";

          let titlemsg = "Please Fill in below details ";
          let alertmsg = "Please Select ";
          if (lang == "th_TH") {
            alertmsg = "กรุณาเลือก";
            titlemsg = "กรอกข้อมูลให้ครบถ้วน ";
          }
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: titlemsg,
                icon: "AlertCircleIcon",
                variant: "danger",
                text: alertmsg + message,
              },
            },
            {
              position: "top-center",
              timeout: 10000,
            }
          );
        }
      });
    },
    onSave() {
      let lang = localStorage.getItem("language");

      this.busy = true;
      this.processing = true;
      this.isSaving = true;

      var dataSave = {
        intUserId: this.listData.intUserId,
        strOldPassword: this.listData.strOldPassword,
        strPassword: this.listData.strInputPassword,
        strConfirmPass: this.listData.strConfirmPassword,
      };
      console.log("dataSave", dataSave);

      let formData = new FormData();
      formData.append("strJson", JSON.stringify(dataSave));

      UserService.saveUser3(formData)
        .then((response) => {
          if (response.data.status == "500") {
            this.busy = false;
            this.processing = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Something was wrong",
                  icon: "FrownIcon",
                  variant: "danger",
                  text: response.data.message,
                },
              },
              {
                position: "top-center",
              }
            );
          } else {
            this.$router.replace({ name: "profile" }).then(() => {
              let compmsg = "Save Completed";
              if (lang == "th_TH") {
                compmsg = "บันทึกสำเร็จ";
              }
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: compmsg,
                    icon: "CheckIcon",
                    variant: "success",
                    text: response.data.message,
                  },
                },
                {
                  position: "top-center",
                }
              );
            });
          }
        })
        .catch((error) => {
          this.busy = false;
          this.processing = false;
          this.isSaving = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onBack() {
      this.$router.push({ name: "profile" });
    },
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";
</style>
